import { Form } from '@unform/web';
import styled from 'styled-components';

import { ButtonConfirm } from '../../components/ButtonConfirm';
import { InputText } from '../../components/InputText';
import { TextInfo } from '../../components/TextInfo';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 500px;

  display: flex;
  flex-direction: column;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled.div`
  padding: 32px;
`;

export const Info = styled(TextInfo)`
  margin: 0 0 16px;
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
`;

export const Input = styled(InputText)`
  margin-bottom: 16px;
`;

export const FixedEmailInfo = styled.p`
  font-size: 13px;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 16px;

  strong {
    color: ${colors.onSurface};
  }
`;

export const RoleFieldLabel = styled.label`
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
`;

export const GymSearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const GymSearchIconWrapper = styled.div`
  position: absolute;
  left: 14px;
  display: flex;
  pointer-events: none;
`;

export const GymSearchInput = styled.input`
  width: 100%;
  height: 42px;

  padding: 0 16px 0 44px;

  background-color: ${colors.surfaceContainer};
  border: none;
  border-radius: ${radius.full};

  font-size: 13px;
  color: ${colors.onSurface};

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }
`;

export const GymResultsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  max-height: 220px;
  overflow-y: auto;

  margin-bottom: 24px;
`;

export const GymResultRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  padding: 10px 14px;
  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  background-color: ${colors.surfaceContainer};
  text-align: left;

  &:hover {
    background-color: ${colors.surfaceContainerHigh};
  }
`;

export const SelectedGymRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  padding: 10px 14px;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.primary};
  background-color: ${colors.primaryContainer};

  margin-bottom: 24px;
`;

export const SelectedGymInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const GymResultIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 32px;
  height: 32px;
  border-radius: ${radius.DEFAULT};
  background-color: ${colors.surfaceContainerHigh};
`;

export const GymResultName = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const GymResultSubtitle = styled.span`
  font-size: 11px;
  color: ${colors.onSurfaceVariant};
`;

export const SwapGymButton = styled.button`
  padding: 4px 12px;
  border-radius: ${radius.full};
  border: 1px solid ${colors.outlineVariant};
  cursor: pointer;

  background-color: transparent;
  color: ${colors.onSurfaceVariant};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;

  white-space: nowrap;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`;

export const Cancel = styled.button`
  padding: 0 20px;
  height: 44px;

  background-color: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const Submit = styled(ButtonConfirm)`
  width: auto;
  height: 44px;
  padding: 0 24px;
  border-radius: ${radius.DEFAULT};
`;
